/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, useContext } from 'react'

import LiveLoading from 'live/components/ui/Loading'
import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import { RemoveConfirmationModal } from 'plugin-codaf-risk-ext-bowtie/generic'
import { deleteAlarmGroup } from 'plugin-codaf-risk-ext-bowtie/services/alarms'
import { IBowtie, IOperation, IAsset } from 'plugin-codaf-risk-ext-bowtie/types'

import { BowtieAlarmsRouteContext } from './BowtieAlarmsWrapper'
import { AlarmsTitle, GroupsList, NewGroupScreen } from './components'
import { AbsoluteLoadingContainer, BowtieAlarmsContainer } from './styles'

export interface IAlarmOperation extends IOperation {
    bowties: IBowtie[]
}
export interface IAlarmsAsset extends IAsset {
    operations: IAlarmOperation[]
}

export const BowtieAlarms: React.FC = () => {
    const [inLoading, setInLoading] = useState(true)
    const [alarmGroupToDelete, setAlarmGroupToDelete] = useState<number>()
    const [alarmNameToDelete, setAlarmNameToDelete] = useState<string>()

    const { params, setParams } = useContext(BowtieAlarmsRouteContext)

    const handleCloseModal = (): void => {
        setAlarmGroupToDelete(undefined)
        if (params?.type !== 'list') {
            setParams({ type: 'list' })
        }
    }

    const handleDeleteGroup = async (): Promise<void> => {
        try {
            setInLoading(true)
            await deleteAlarmGroup(alarmGroupToDelete)
        } catch (err) {
            console.error(err)
            globalNotification.error(err.message ?? i18n('An error occurred on list alarm groups.'))
        } finally {
            setInLoading(false)
        }
    }

    return (
        <>
            <BowtieAlarmsContainer style={params.type === 'edit' ? { padding: 0 } : {}}>
                {params.type === 'edit' ? (
                    <NewGroupScreen
                        alarmGroupToDelete={alarmGroupToDelete}
                        alarmGroupNameToDelete={alarmNameToDelete}
                        setAlarmGroupToDelete={setAlarmGroupToDelete}
                        setAlarmGroupNameToDelete={setAlarmNameToDelete}
                        setInLoading={setInLoading}
                    />
                ) : (
                    <>
                        <AlarmsTitle />
                        <GroupsList
                            alarmGroupToDelete={alarmGroupToDelete}
                            alarmGroupNameToDelete={alarmNameToDelete}
                            setAlarmGroupToDelete={setAlarmGroupToDelete}
                            setAlarmGroupNameToDelete={setAlarmNameToDelete}
                            setInLoading={setInLoading}
                        />
                    </>
                )}
            </BowtieAlarmsContainer>
            <RemoveConfirmationModal
                handleClose={handleCloseModal}
                onDelete={handleDeleteGroup}
                show={!!alarmGroupToDelete}
                setShow={() => setAlarmGroupToDelete(undefined)}
                type="alarm group"
                removalMessage={`${i18n('Are you sure you want remove the alarm group')} ${alarmNameToDelete}?`}
                successMessage={i18n('The alarms group was deleted successfully.')}
            />
            {inLoading && (
                <AbsoluteLoadingContainer>
                    <h3>{i18n('Loading')}</h3>
                    <div>
                        <LiveLoading size="lg" show />
                    </div>
                </AbsoluteLoadingContainer>
            )}
        </>
    )
}
